import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

export type ExamLabel = { id: string; slug: string; name: string };

interface ExamLabelPickerProps {
  labels: ExamLabel[];
  value: string[];
  onChange: (ids: string[]) => void;
}

const ExamLabelPicker = ({ labels, value, onChange }: ExamLabelPickerProps) => {
  const toggle = (id: string) => {
    const set = new Set(value);
    if (set.has(id)) set.delete(id); else set.add(id);
    onChange(Array.from(set));
  };
  return (
    <div className="space-y-2">
      <div className="text-sm font-medium">Exam labels</div>
      <div className="grid gap-2 sm:grid-cols-2">
        {labels.map((l) => (
          <label key={l.id} className="flex items-center gap-2 rounded-md border p-2">
            <Checkbox checked={value.includes(l.id)} onCheckedChange={() => toggle(l.id)} />
            <Label className="cursor-pointer">{l.name} <span className="text-xs text-muted-foreground">({l.slug})</span></Label>
          </label>
        ))}
      </div>
    </div>
  );
};

export default ExamLabelPicker;
